import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const AreaChart = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 64 64" {...props}>
    <path
      fill={getColor(color, isColorInherited)}
      d="M48,20L40,8l-8,20l-8-4l-8,12L4,32v16v12h56V22v-6L48,20z M58,58H6v-8.6l10.6-3.5l0.4-0.1l0.3-0.3l7-7l6.7,3.4l1.7,0.8l0.9-1.6l6.5-11.4l6.2,7.7l1.5,1.9l1.6-1.8l8.5-9.9V58z M48,36l-8-10l-8,14l-8-4l-8,8L6,47.3V34.8l9.4,3.1l1.4,0.5l0.8-1.3l7-10.5l6.4,3.2l1.9,1l0.8-2l6.6-16.5l5.9,8.8l0.8,1.3l1.4-0.5l9.4-3.1v5.6L48,36z"
    />
    <path
      strokeWidth="2"
      stroke={getColor(color, isColorInherited)}
      d="M4,48V32l12,4l8-12l8,4l8-20l8,12l12-4v6L48,36l-8-10l-8,14l-8-4l-8,8L4,48z"
    />
    <path
      strokeWidth="2"
      stroke={getColor(color, isColorInherited)}
      d="M17.1,45.7l7.3-7.3l8.4,4.2l7.5-13.1l7.7,9.6L60,25.1V60H4v-9.9L17.1,45.7z"
    />
  </SvgIcon>
);
